import styled from 'styled-components';

import ListContainer from '@r1-frontend/ui-react/experimental/containers/ListContainer';

const FullWidthListContainer = styled(ListContainer)`
    width: 100%;
`;

export default FullWidthListContainer;
